import type { ReactNode } from 'react'
import { SuspenseLoader } from 'v2/shared/components/suspense-loader'
import { useFeatureFlags } from 'v2/shared/hooks/use-feature-flags'
import { useFeatureFlagsFetchFailed } from 'v2/shared/hooks/use-feature-flags-fetch-failed'
import { usePageAccess } from 'v2/shared/hooks/use-page-access'
import { useWorkspaceSidebarEnabled } from 'v2/shared/hooks/use-workspace-sidebar-enabled'

export const FlowSectionGate = ({ children }: { children: ReactNode }) => {
  const { isInitialData } = useFeatureFlags()
  // The sidebar's own reading of the flag, so a failed flags fetch can't list Flow and deny it.
  const workspaceSidebarEnabled = useWorkspaceSidebarEnabled()
  const flagsFetchFailed = useFeatureFlagsFetchFailed()
  const access = usePageAccess(workspaceSidebarEnabled, 'feature')
  // Flags read false until hodor answers, so a deep link waits instead of flashing a denial.
  if (isInitialData && !flagsFetchFailed) return <SuspenseLoader />
  if (!access.allowed) return access.fallback
  return children
}
